module.exports = __webpack_public_path__ + "static/media/list-icon.7deb6d20.svg";